import ClientSearchActions from "@redux/feature/Clients/action/ClientSearchActions";
import ClientHeaderAccCode from "@redux/feature/Clients/action/ClientHeaderAccCode";
import ClientOverview from "@redux/feature/Clients/action/ClientOverview";
import ClientHeaderAUMActions from "@redux/feature/Clients/action/ClientHeaderAUMActions";
import ClientMultipleContactsActions from "@redux/feature/Clients/action/ClientMultipleContactsActions";
import ClientMCAccessActions from "@redux/feature/Clients/action/ClientMCAccessActions";
import PasswordResentHistoryActions from "@redux/feature/Clients/action/PasswordResentHistoryActions";
import OwnerHistoryActions from "@redux/feature/Clients/action/OwnerHistory";
import DPDetialsActions from "@redux/feature/Clients/action/DPDetials";
import BankDetailsActions from "@redux/feature/Clients/action/BankDetailsActions";
import RevAUMDataActions from "@redux/feature/Clients/action/IRevenueAUMActions";
import RevActiveLoansActions from "@redux/feature/Clients/action/IRevenueActiveLoans";
import FamilyMemDetailsActions from "@redux/feature/Clients/action/FamilyMemDetails";
import HistoricalViewActions from "@redux/feature/Clients/action/HistoricalViewActions";
import ClientPassthroughActions from "@redux/feature/Clients/action/ClientPassthroughActions";
import ClientBackOfficeUrlActions from "@redux/feature/Clients/action/ClientBackOfficeUrlActions";
import MFRegistrationBookActions from "@redux/feature/Clients/action/MFRegistrationBookActions";
import MFOrderBookActions from "@redux/feature/Clients/action/MFOrderBookActions";
import GetExceptionlsinActions from "@redux/feature/Clients/action/GetExceptionlsinActions";
import PartnerProfDemMetNomSegActions from "@redux/feature/Partners/action/PartnerProfDemMetNomSeg";
import PartnerSummaryActions from "@redux/feature/Partners/action/PartnerSummaryActions";
export default (function () {
    return {
        clients: {
            clientSearch: new ClientSearchActions(),
            clientHeaderAccCode: new ClientHeaderAccCode(),
            clientOverview: new ClientOverview(),
            clientHeaderAUM: new ClientHeaderAUMActions(),
            clientMultipleContent: new ClientMultipleContactsActions(),
            clientMCAccess: new ClientMCAccessActions(),
            passwordResentHistory: new PasswordResentHistoryActions(),
            ownerHistory: new OwnerHistoryActions(),
            dpDetails: new DPDetialsActions(),
            bankDetails: new BankDetailsActions(),
            revAUMData: new RevAUMDataActions(),
            revActiveLoans: new RevActiveLoansActions(),
            familyMemDetails: new FamilyMemDetailsActions(),
            historicalView: new HistoricalViewActions(),
            clientPassthrough: new ClientPassthroughActions(),
            clientBackOfficeUrl: new ClientBackOfficeUrlActions(),
            mfRegistrationBook: new MFRegistrationBookActions(),
            mfOrderBook: new MFOrderBookActions(),
            getExceptionlsin: new GetExceptionlsinActions(),
        },
        partners: {
            partnerProfDemMetNomSeg: new PartnerProfDemMetNomSegActions(),
            partnerSummary: new PartnerSummaryActions(),
        },
    };
});
